<template>
  <div v-if="data !== null">
  <nav class="navbar navbar-expand-lg navbar-light fixed-top bg-white">
    <!-- Ifall ej inloggad med notRoot check -->
    <a class="navbar-brand" :href="'/landingpage'" v-if="notRoot() && !isFaq()">
      <img
        src="@/assets/img/logo.svg?data"
        alt="Logotyp FHabianklinik.nu"
        class="img-fluid img-logo"
      />
    </a>
    <a class="navbar-brand" :href="'/'" v-if="!notRoot() || isFaq()">
      <img
        src="@/assets/img/logo.svg?data"
        alt="Logotyp FHabianklinik.nu"
        class="img-fluid img-logo"
      />
    </a>
    <!-- Ifall inloggad -->
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
      v-if="metaRoute()"
    >
    <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Ifall inloggad -->
    <div
      class="collapse navbar-collapse"
      id="navbarSupportedContent"
      v-if="metaRoute()">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <span class="nav-link fhabian-nav-secondary">
            <small v-if="clinic"><span>{{ clinic }}</span></small>
            <small v-if="!clinic"><span class="div-loader">Laddar</span></small>
          </span>
        </li>
        <li class="nav-item" v-show="showSearch()">
          <div class="input-group input-group-sm search mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                <img
                  src="@/assets/img/magn-glass-icon.svg?data"
                  alt="Ett förstoringsglas"
                  class="img-fluid"
                />
              </span>
            </div>
            <input
              type="text"
              class="form-control search-field"
              aria-label="Sökfält"
              aria-describedby="basic-addon1"
            >
          </div>
        </li>
      </ul>
      <div class="topnav-right dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <img
          src="@/assets/img/flower-icon.svg?data"
          alt="En blomma"
          class="img-fluid"
        />
        <div class="vertical-hr"></div>
        <span class="div-loader" v-if="!fullname">Laddar</span>
        <span v-if="fullname">{{ fullname }}</span>
        <div class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownMenuButton">
          <span class="dropdown-item" @click="logOut()">Logga ut</span>
        </div>
      </div>
    </div>
    <!-- Ifall ej inloggad -->
    <router-link to="/faq">
      <img
        src="@/assets/img/q-icon.svg?data"
        alt="En informationsikon"
        class="img-fluid top-right-icon info-icon cursor-pointer"
        v-if="!metaRoute()"
      />
    </router-link>
  </nav>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'

export default {
  name: 'top',
  data () {
    return {
      data: null,
      clinic: localStorage.getItem('clinicName'),
      fullname: localStorage.getItem('fullname'),
      pages: {
        whatisfh: 'whatisfh',
        treatfh: 'treatfh',
        aboutapp: 'aboutapp',
        helpresearch: 'helpresearch'
      },
      root: '/'
    }
  },
  methods: {
    notRoot () {
      return location.pathname !== '/'
    },
    isFaq () {
      return location.pathname === '/faq'
    },
    metaRoute () {
      if (this.$route.meta.showData) {
        return true
      } else {
        return false
      }
    },
    showSearch () {
      if (this.$route.meta.showSearch) {
        return true
      } else {
        return false
      }
    },
    logOut () {
      const cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      const jumboTodo = localStorage.getItem('jumbotron-closed-todo')
      const jumboDashboard = localStorage.getItem('jumbotron-closed-dashboard')

      localStorage.clear()
      sessionStorage.clear()

      if (cookies) localStorage.setItem('vue-cookie-accept-decline-cookies', 'accept')
      if (jumboTodo) localStorage.setItem('jumbotron-closed-todo', true)
      if (jumboDashboard) localStorage.setItem('jumbotron-closed-dashboard', true)

      document.location.href = '/'
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          clinicMisc {
            receptionlist
          }
        }
      `
    })
    this.$root.$on('setClinic', (clinic) => {
      if (clinic) {
        this.clinic = clinic
      }
    })
    this.$root.$on('setName', (name) => {
      if (name) {
        this.fullname = name
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
select {
  border: none;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -ms-appearance: none;
  padding: 5px;
  font-size: 1em;
}
select:focus {
  outline: none;
}
nav {
  filter: drop-shadow(225px 4px 14px rgba(224, 208, 192, 0.73));
}
.navbar-toggler {
  cursor: pointer;
  border: 0;
}
.navbar-header {
  margin-top: 1vh;
}
.nav-link {
  font-size: 20px;
  float: right;
  margin-left: 10px;
}
.navbar-span {
  margin-left: .5em;
}
.search {
  width: 20vw;
}
.img-logo {
  width: 18vw;
}
.dropdown {
  cursor: pointer;
}
.input-group-text {
  background: #fff !important;
}
.back-forward-wrapper {
  cursor: pointer;
  opacity: 0.8;
  font-size: 25px;
  padding-left: 10px;
}
.topnav-right .vertical-hr {
  margin-right: 1vw;
  margin-left: 1vw;
}
.top-right-icon {
  top: 0;
  right: 0;
  position: absolute;
}
.info-icon {
  margin: 20px;
}
.vertical-hr {
  border-left: 2px solid #DEDEDE;
  display: inline;
}
.justify-hr {
  margin-left: 2.5vw;
}
.search {
  margin-top: 1vh;
}
.search-field {
  border-left-color: #fff;
}
.fhabian-nav-secondary {
  cursor: pointer;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .img-logo {
    width: 48vw;
  }
  .navbar-collapse {
    display: block !important;
  }
  .navbar-nav {
    display: none !important;
  }
  .topnav-right {
    margin: 2em;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 60% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue